import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InfiniteResult } from '../_models/body';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AiAgentGroupService {

  constructor(private http: HttpClient) { }
  getAll() {
    return this.http.get<InfiniteResult>(`${environment.apiEndpoint}api/AiAgentGroup/Query`, {
      params: {
        PageSize: '-1'
      }
    });
  }

  delete(id: string) {
    return this.http.delete<any>(`${environment.apiEndpoint}/api/AiAgentGroup/${id}`);
  }

  edit(id, formGroup) {
    return this.http.put<any>(`${environment.apiEndpoint}api/AiAgentGroup/${id}`, formGroup);
  }

  create(formGroup) {
    return this.http.post<any>(`${environment.apiEndpoint}api/AiAgentGroup`, formGroup);
  }


}
